<template>
  <div ref="word" class="words" :class="[!showbtn || expended ? '' : 'expend-box']" :content="text">
    {{ text }}
    <span v-if="showbtn" class="btn" @click="expendedFunc">{{ expended ? '收起' : '展开' }}</span>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      expended: false,
      showbtn: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.showbtn = this.$refs.word.getBoundingClientRect().height > ((4 * 1.52778) / 100) * window.innerWidth
    })
  },
  methods: {
    expendedFunc() {
      this.expended = !this.expended
    },
  },
}
</script>
<style lang="less" scoped>
.expend-box {
  user-select: none;
  max-height: 88px;
  color: #fff;
  overflow: hidden;
  &::before {
    max-height: 66px;
    z-index: 2;
    background: #fff;
  }
  &::after {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-line-clamp: 4;
    text-indent: -9em;
    padding-right: 3em;
  }
  &::before,
  &::after {
    content: attr(content);
    overflow: hidden;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    color: #666;
    line-height: 22px;
  }
}
&.words {
  position: relative;
  width: calc(100% - 40px);
  line-height: 22px;
  .btn {
    position: absolute;
    right: 8px;
    bottom: -1px;
    z-index: 3;
    color: #1471fc;
    line-height: 22px;
    cursor: pointer;
  }
}
</style>
